export const filterFields = (translations, gt) => [
  { name: 'failureAnalysisEngineerNotAssigned', label: translations.failureAnalysisEngineerNotAssigned, type: 'switch' },
  { name: 'unreadMessages', label: translations.unreadMessages, type: 'switch' },
  { name: 'pendingMyApproval', label: translations.pendingMyApproval, type: 'switch' },
  { name: 'finalReportReleased', label: gt.finalReportReleased, type: 'switch' },
  { name: 'notificationNumber', label: translations.notificationNumber, type: 'input' },
  { name: 'serviceOrderNumber', label: translations.serviceOrderNumber, type: 'input' },
];



// WEBPACK FOOTER //
// ./src/components/Jobs/TopFilters/constants.js